import { render, staticRenderFns } from "./FrFormSwitch.vue?vue&type=template&id=7a03d55f&"
import script from "./FrFormSwitch.vue?vue&type=script&lang=js&"
export * from "./FrFormSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports